import React from 'react';
import {Platform, TouchableOpacity} from 'react-native';
import {Button as RNEButton, ButtonProps} from '@rn-vui/themed';

const Button = (props: ButtonProps) => {
  // Android-specific: TouchableNativeFeedback ignores buttonStyle.backgroundColor
  // due to how it renders ripple effects over a solid background. TouchableOpacity
  // respects inline styles correctly.
  // Type cast needed: ButtonProps.TouchableComponent expects React.Component type,
  // but TouchableOpacity is a functional component at runtime.
  const platformProps: Partial<ButtonProps> =
    Platform.OS === 'android'
      ? {TouchableComponent: TouchableOpacity as unknown as typeof React.Component}
      : {};

  return (
    <RNEButton
      radius="sm"
      size="sm"
      {...platformProps}
      {...props}
      buttonStyle={[
        {
          width: 200,
          alignSelf: 'center',
        },
        props.buttonStyle,
      ]}
    />
  );
};

export default Button;
